const Percentage = (a, b) => {
  if (!a || !b) return '';
  return `${((b / a) * 100).toFixed(0)}%`;
};

export default Percentage;
